import { resolveModuleType } from "../config/moduleTypes";

// Fallback support flags for an unrecognized module type — matches the original switch
// statements' `default` branches (theory/test/trainingPercentage all true).
const DEFAULT_SUPPORT = { theory: true, test: true, trainingPercentage: true };

export const isModuleVRSafe = (moduleType) => resolveModuleType(moduleType)?.key === "mental";
export const isModuleVRObs = (moduleType) => resolveModuleType(moduleType)?.key === "fysisk";
export const isModuleVRAid = (moduleType) => resolveModuleType(moduleType)?.key === "forstehjelp";
export const isModuleSecuritas = (moduleType) => resolveModuleType(moduleType)?.key === "securitas";
export const isModuleSykefravaer = (moduleType) => resolveModuleType(moduleType)?.key === "sykefravaer";

/**
 * Get support flags for a module type
 * Determines whether training, theory, and test features are supported
 * @param {string} moduleType
 * @returns {Object} { supportsTrainingPercentage, supportsTheory, supportsTest }
 */
export const getModuleSupportFlags = (moduleType) => {
  const support = resolveModuleType(moduleType)?.support ?? DEFAULT_SUPPORT;

  return {
    supportsTrainingPercentage: support.trainingPercentage,
    supportsTraining: true, // unconditional for every type, same as the original implementation
    supportsTheory: support.theory,
    supportsTest: support.test,

    isModuleVRSafe: isModuleVRSafe(moduleType),
    isModuleVRObs: isModuleVRObs(moduleType),
    isModuleVRAid: isModuleVRAid(moduleType),
    isModuleSecuritas: isModuleSecuritas(moduleType),
    isModuleSykefravaer: isModuleSykefravaer(moduleType),
  };
};
